import { Stack } from "@mui/material";
import { ResponsiveStyleValue, SxProps, Theme } from "@mui/system";
import React, { PropsWithChildren } from "react";

export type ContentContainerProps = {
    spacing?: ResponsiveStyleValue<number | string>;
    sx?: SxProps<Theme>
};

export function ContentContainer({ spacing, children, sx }: PropsWithChildren<ContentContainerProps>) {
    return (
        <Stack id='contentcontainer'
            direction="row"
            sx={{
                overflow: "hidden",
                flexGrow: 1,
                ...sx
            }}
            spacing={spacing}
        >
            {children}
        </Stack>
    );
}
